import { reportNativeBridgeFailure } from 'src/dataLayer/remoteData/rollbar'

// One of the two bridges is always expected to fail (an iOS device has no
// Android listener and vice versa), so a single failure is not an error.
// Only when BOTH bridges fail has the message been lost — that is the case
// we need to report, because the native app never receives the auth token.
const tryBridges = (method, iosCall, androidCall, payload) => {
  let failures = 0

  try {
    iosCall()
  } catch (error) {
    failures += 1
    console.error(`iOS ${method}:`, error)
  }
  try {
    androidCall()
  } catch (error) {
    failures += 1
    console.error(`Android ${method}:`, error)
  }

  if (failures === 2) {
    reportNativeBridgeFailure(method, payload)
  }
}

const postMessage = (message) => {
  if (!message) console.error('Missing postMessage string parameter')

  tryBridges(
    'postMessage',
    () => globalThis.webkit.messageHandlers.iosAuthTokenListener.postMessage(message),
    () => globalThis.androidListener.postMessage(message),
    { hasMessage: Boolean(message) },
  )
}

const onBackButtonClicked = () => {
  tryBridges(
    'onBackButtonClicked',
    () => globalThis.webkit.messageHandlers.iosUIListener.postMessage('onBackButtonClicked'),
    () => globalThis.androidListener.onBackButtonClicked(),
  )
}

const onForgotPasswordClicked = () => {
  tryBridges(
    'onForgotPasswordClicked',
    () => globalThis.webkit.messageHandlers.iosUIListener.postMessage('onForgotPasswordClicked'),
    () => globalThis.androidListener.onForgotPasswordClicked(),
  )
}
export { onBackButtonClicked, onForgotPasswordClicked, postMessage }
